var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#CACACE","d":"M4.55 38a3.8 3.8 0 01-2.7-6.49l12.56-12.48L2.35 6.47a3.8 3.8 0 115.39-5.35L22.38 16.3a3.8 3.8 0 010 5.31L7.2 36.79A3.8 3.8 0 014.55 38z","key":1})]);
}

Chevron.defaultProps = {"fill":"none","viewBox":"0 0 24 38"};

module.exports = Chevron;

Chevron.default = Chevron;
